<template>
  <div class="reception-status" :class="className">{{ label }}</div>
</template>

<script>
export default {
  name: 'ReceptionStatus',
  props: {
    status: { type: [Number, String], required: true },
  },
  computed: {
    className() {
      return {
        1: 'new',
        2: 'change',
        3: 'cancel',
        新規受付: 'new',
        変更: 'change',
        キャンセル: 'cancel',
      }[this.status]
    },
    label() {
      return { 1: '新規受付', 2: '変更', 3: 'キャンセル', 99: 'その他' }[this.status] || this.status
    },
  },
}
</script>

<style lang="postcss" scoped>
.reception-status {
  align-items: center;
  border: 2px solid var(--dark-gray);
  box-sizing: border-box;
  color: var(--dark-gray);
  display: flex;
  font-weight: 600;
  height: 28px;
  justify-content: center;
  width: 104px;

  &.new {
    border-color: var(--brand-color);
    color: var(--brand-color);
  }

  &.change {
    background: var(--pure-red);
    border-color: var(--pure-red);
    color: var(--white);
  }

  &.cancel {
    background-color: var(--dark-gray);
    color: var(--white);
  }

  .responsive & {
    @media screen and (--sp-size) {
      border-width: 1px;
      font-size: 11px;
      height: 24px;
      width: 64px;
    }
  }
}
</style>
